import { useState, useEffect } from 'react';
import './Navbar.css';
import logo from './company-logo.png';

const LINKS = [
  { label: 'Platform',        href: '#what' },
  { label: 'Admin Portal',    href: '#admin' },
  { label: 'Candidate Portal',href: '#candidate' },
  { label: 'Features',        href: '#features' },
  { label: 'How It Works',    href: '#how' },
  { label: 'Contact',         href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__logo" onClick={() => window.scrollTo({top:0,behavior:'smooth'})} style={{cursor:'pointer'}}>
        <div className="navbar__v-mark">
  <img src={logo} alt="Verdict Logo" className="navbar__logo-img" />
</div>
        <div>
          <div className="navbar__name">VERDICT</div>
          <div className="navbar__sub">by Aiprus Software</div>
        </div>
      </div>

      <ul className={`navbar__links ${open ? 'navbar__links--open' : ''}`}>
        {LINKS.map(l => (
          <li key={l.href}>
            <button className="navbar__link-btn" onClick={() => handleNav(l.href)}>{l.label}</button>
          </li>
        ))}
      </ul>

      <div className="navbar__right">
        <button className="btn-purple navbar__cta" onClick={() => handleNav('#contact')}>Get a Demo</button>
        <button className={`navbar__burger ${open ? 'open' : ''}`} onClick={() => setOpen(!open)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
